<mat-card appearance="outlined">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" color="primary" />
  }
  <mat-card-header class="flex-row">
    <mat-card-title class="flex-1">Organizations</mat-card-title>
    <div class="text-right flex-1">
      <lib-button color="primary" (click)="onAdd()" icon="corporate_fare">Add Organization</lib-button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <lib-data-table [data]="organizations" [columns]="columns" [showPaginator]="false" [showFilter]="false" />
  </mat-card-content>
</mat-card>